// Lib
import React, { createContext } from 'react';
import { Provider, createDispatchHook } from 'react-redux';
import { ImElementMeasurementMap } from './elementMeasurements/elementMeasurementsTypes';

export const MeasurementsStoreContext = createContext({});

export const MeasurementsProvider = (props: any) => <Provider context={MeasurementsStoreContext} {...props} />;

export const useMeasurementsDispatch = createDispatchHook<ImElementMeasurementMap, any>(MeasurementsStoreContext);
